import { CustomerRepository } from "../../repositories/CustomerRepository";
import { CustomerGroupsResult } from "../../entities/CustomerEntity";

/**
 * Get Customer Groups Use Case
 * Retrieves all customer groups
 */
export class GetCustomerGroupsUseCase {
  constructor(private repository: CustomerRepository) {}

  async execute(): Promise<CustomerGroupsResult> {
    return await this.repository.fetchCustomerGroups();
  }
}

